import ViewPoint from "@arcgis/core/Viewpoint";
import { MapSettings } from "../types/types";
import { normalizeMapSettings } from "./labelSettings";

export const storeViewPoint = (viewPoint: ViewPoint) => {
    if (!viewPoint) return;
    const viewPointString = viewPoint?.toJSON();
    const viewPointStoreObject = {
        storeDate: new Date().toISOString(),
        viewPoint: viewPointString,
    };

    if (viewPointString) {
        localStorage.setItem("viewPoint", JSON.stringify(viewPointStoreObject));
    }
};

export const getViewPoint = (): ViewPoint | null => {
    const viewPointString = localStorage.getItem("viewPoint");
    const viewPointStoreObject = viewPointString ? JSON.parse(viewPointString) : null;
    if (!viewPointStoreObject) {
        return null;
    }

    if (viewPointStoreObject) {
        return ViewPoint.fromJSON(viewPointStoreObject.viewPoint);
    }
    return null;
};

export const getMapSettings = (): MapSettings | null => {
    const mapSettingsString = localStorage.getItem("mapSettings");
    try {
        const mapSettingsObject = mapSettingsString ? JSON.parse(mapSettingsString) : null;
        return normalizeMapSettings(mapSettingsObject);
    } catch (error) {
        console.error("Error parsing map settings from localStorage:", error);
        return null;
    }
};

export const storeMapSettings = (mapSettings: MapSettings) => {
    if (!mapSettings) return;
    localStorage.setItem("mapSettings", JSON.stringify(mapSettings));
};
